import { render, staticRenderFns } from "./AFAS_3_Code_Tests.vue?vue&type=template&id=0940d67c&"
import script from "./AFAS_3_Code_Tests.vue?vue&type=script&lang=js&"
export * from "./AFAS_3_Code_Tests.vue?vue&type=script&lang=js&"
import style0 from "./AFAS_3_Code_Tests.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports